import React from "react";
import './App.css';


const About = () =>{
     return(
        <div>
            <h1>About the Long Island Retro Gaming Expo</h1><br/>
            <h3 className="large-text">A True Celebration of Classic Gaming</h3>
            <span className="large-text">Visit <a className="large-text" href="https://www.liretro.com">www.liretro.com</a>tickets and more information.</span><br/><br/>

            <h3 className="large-text">Expo Hours:</h3>
            <p className="large-text">Friday, August 11th - 4pm - 10pm (Vendor Marketplace closes 8pm)</p>
            <p className="large-text">Saturday, August 12th - 10am - 10pm (Vendor Marketplace closes at 7pm)</p>
            <p className="large-text">Sunday, August 13th - 10am - 5pm </p><br/><br/>
        </div>
     );
};
export default About;